/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Table from "../../common/Table";
import Body from "../../components/Body";
import api from "../../config/api";
import useHeader from "../../hooks/useHeader";
import moment from "moment";
import addPrecision from "../../common/addPrecision";
import numberFormat from "../../common/numberFormat";
import TableMenu from "../../components/TableMenu";
import AppButton from "../../common/AppButton";
import AppModal from "../../common/AppModal";
import RebateModel from "./RebateModel";
import { BiPlus, BiTrash } from "react-icons/bi";
import { FaRegListAlt } from "react-icons/fa";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { getIncomeRebates } from "../../stores/IncomeRebateStore";
import { useQuery, useQueryClient } from "@tanstack/react-query";

const header = [
  { name: "date", title: "Date", filter: "DatePicker" },
  { name: "amount", title: "Amount ($)" },
  { name: "type", title: "Type", filter: "Select" },
  { name: "comment", title: "Comment" },
];

const LIMIT = 100;
export default function IncomeList() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setHeader } = useHeader();
  const [data, setData] = useState([]);
  const [model, setModel] = useState({});
  const Rebate = RebateModel();
  const queryClient = useQueryClient();
  const [loadingMore, setLoadingMore] = useState(false);
  const [skip, setSkip] = useState(LIMIT);

  useEffect(() => {
    setHeader("Summary");
  }, []);

  const { data: incomeRebates, refetch } = useQuery({
    queryFn: () => getIncomeRebates({ limit: skip }),
    queryKey: ["incomeRebates", LIMIT],
  });

  useEffect(() => {
    if (incomeRebates) {
      setData(
        incomeRebates.map((i) => {
          return {
            ...i,
            date: moment(i.date).format("DD/MM/YYYY"),
            amount: addPrecision(numberFormat(i.amount)),
          };
        })
      );
    }
  }, [incomeRebates]);

  const handleLoadMore = async () => {
    setLoadingMore(true);
    setSkip(skip + LIMIT);
  };

  useEffect(() => {
    refetch();
    setLoadingMore(false);
  }, [skip]);

  const deleteRebate = async (rebate) => {
    console.log(rebate);
    const res = await api.put("rebate", { _id: rebate._id, isDeleted: true });
    if (!res.ok) return toast.error(res.originalError.message);
    queryClient.invalidateQueries(["incomeRebates"]);

    toast.success("Salary has been successfully deleted.");
  };
  const deleteInvoicePayment = async (payment) => {
    const res = await api.put("jobPayments", {
      _id: payment._id,
      isDeleted: true,
    });
    if (!res.ok) return toast.error(res.originalError.message);

    queryClient.invalidateQueries(["incomeRebates"], ["jobPayments"]);
    toast.success("Salary has been successfully deleted.");
  };

  const deleteSalary = async (salary) => {
    const res = await api.put("salary", { _id: salary._id, isDeleted: true });
    if (!res.ok) return toast.error(res.originalError.message);

    queryClient.invalidateQueries(["incomeRebates"], ["salary"]);
    toast.success("Salary has been successfully deleted.");
  };
  const deleteExpense = async (expense) => {
    const res = await api.put("expenses", {
      _id: expense._id,
      isDeleted: true,
    });
    if (!res.ok) return toast.error(res.originalError.message);
    queryClient.invalidateQueries(["incomeRebates"], ["expenses"]);
    toast.success("Expense has been successfully deleted.");
  };
  const handleDelete = async (item) => {
    // eslint-disable-next-line no-restricted-globals
    if (confirm(`Are you sure want to delete this ${item.type} ? `) === false)
      return false;
    if (item.type === "Rebate") return deleteRebate(item);
    if (item.type === "Invoice Payment") return deleteInvoicePayment(item);
    if (item.type === "Salary") return deleteSalary(item);
    if (item.type === "Expense") return deleteExpense(item);
  };
  return (
    <React.Fragment>
      <Body noPadding>
        <div style={{ width: "100%" }}>
          <TableMenu
            style={{
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <AppButton
              tooltip="Generate Statement"
              onClick={() => {
                const { pathname } = location;
                navigate(pathname + "/statement");
              }}
              leftIcon={<FaRegListAlt size={25} />}
              className="btn"
            />

            <AppButton
              tooltip="Add Other Income"
              onClick={() => {
                setModel({
                  visible: true,

                  model: (
                    <Rebate.Body
                      onDone={() => {
                        setModel({});
                      }}
                    />
                  ),
                });
              }}
              leftIcon={<BiPlus size={35} />}
              className="btn"
            />
          </TableMenu>
          <Table
            countNumber={false}
            header={header}
            data={data}
            SideButtons={({ inv }) => {
              return (
                <div className="side-button">
                  <AppButton
                    tooltip={`Delete ${inv.type}`}
                    onClick={() => handleDelete(inv)}
                    className="text-primary"
                    leftIcon={<BiTrash />}
                  />
                </div>
              );
            }}
          />

          <AppModal
            {...model}
            onHide={() => {
              setModel({});
            }}
          />
        </div>
      </Body>
      {data?.length > 0 && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: 20,
          }}
        >
          <AppButton
            onClick={handleLoadMore}
            text="Load more..."
            className="btn-secondary"
            disabled={loadingMore}
          />
        </div>
      )}
    </React.Fragment>
  );
}
